import {types} from './types';

const setGetUsersListAction = (payload) => {
    return {
        type: types.SET_SEARCH_USERS_LIST,
        payload,
      }
}

export {
  setGetUsersListAction
}
